import { useAppSelector } from "features/store";

export interface PlatformRole {
  /** PlatformUser.is_superuser. */
  isSuperuser: boolean;
  /** PlatformUser.is_calibrate_manager. */
  isCalibrateManager: boolean;
  /** PlatformUser.is_developer. */
  isDeveloper: boolean;
  /** Read tier: developer, superuser or calibrate manager - may open every
   * integration-platform page (managers see everything read-only, incl.
   * revealing secret values). */
  canView: boolean;
  /** Write tier: developer or superuser - settings, connections, secrets,
   * schedules, webhooks, Run Now. */
  canEdit: boolean;
  /** Developer only: integration lifecycle (register/delete) and pipeline
   * structure (add/remove steps, stage/order). */
  canManageStructure: boolean;
}

/**
 * Current user's integration-platform role tiers, mirroring the backend gates
 * (integration_platform/api/core/permissions.py, CAL-5831/CAL-5832). These are
 * visibility gates only - the API enforces its own permissions regardless.
 */
export function usePlatformRole(): PlatformRole {
  const profile = useAppSelector((state) => state.auth.user?.platform_profile);
  const notArchived = !profile?.is_archived;
  const isSuperuser = !!profile?.is_superuser && notArchived;
  const isCalibrateManager = !!profile?.is_calibrate_manager && notArchived;
  const isDeveloper = !!profile?.is_developer && notArchived;
  return {
    isSuperuser,
    isCalibrateManager,
    isDeveloper,
    canView: isDeveloper || isSuperuser || isCalibrateManager,
    canEdit: isDeveloper || isSuperuser,
    canManageStructure: isDeveloper,
  };
}
